import i18n from '../i18n'

const BEACON_IDS = {
  en: '114f4cc9-d0a8-42de-9e65-b785ab11977b',
  fi: '0c32849c-f89d-4e51-a772-8f5889ca2f20',
}

const FALLBACK_LANG = 'en'

function initBeaconForLanguage(lang) {
  if (typeof window === 'undefined' || !window.Beacon) return

  const normalized = (lang || '').split('-')[0]
  const beaconId = BEACON_IDS[normalized] ?? BEACON_IDS[FALLBACK_LANG]

  window.Beacon('destroy')
  window.Beacon('init', beaconId)
}

export function setupHelpScoutI18nSync() {
  initBeaconForLanguage(i18n.language)

  const handler = (lng) => {
    initBeaconForLanguage(lng)
  }

  i18n.on('languageChanged', handler)

  return () => {
    i18n.off('languageChanged', handler)
  }
}
